import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import request from '@/utils/request'

// 使用Element-UI
Vue.use(ElementUI)

// 配置自定义 axios 封装
Vue.prototype.$http = request

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app') 